import { MODES_CONTENT_TABLE } from '../../../../../constans';
import { CheckButton } from '../../../../Basic/Buttons';
import { HeaderTitle, TableHeader } from '../../../../Basic/Table';
import FilterMarketsDropDown from '../FilterMarketsDropDown';
import styles from '../styles.module.scss';

export const WIDTH_CONTENT_TABLE = [
  '80px', //0
  '150px', //1
  '400px', //2
  '100px', //3
  '120px', //4
  '60px', //5
  '150px', //6
  '180px', //7
  '200px', //8
  '250px', //9
  '50px', //10
  '130px', //11
];
const ProductsTableHeader = ({
  markets,
  contentMode = '',
  providerId,
  checkAll = '',
  isSmallProvider = false,
  isContentUser = true,
  isMinPackage = false,
  isAdmin = true,
  isCityStocks = false,
  setMarkets = (_) => _,
  loadProducts = (_) => _,
  clickCheckAll = (_) => _,
}) => {
  return (
    <TableHeader whiteHeader={true} styles={styles.table_line}>
      <HeaderTitle width={WIDTH_CONTENT_TABLE[10]}>
        <CheckButton checked={checkAll} onSelect={(v) => clickCheckAll(v)} />
      </HeaderTitle>
      <HeaderTitle width={WIDTH_CONTENT_TABLE[0]} />
      <HeaderTitle width={WIDTH_CONTENT_TABLE[1]}>
        {contentMode === MODES_CONTENT_TABLE.STOCKS ? 'Артикул / Бренд' : 'Артикул'}
      </HeaderTitle>
      {(providerId === 29 || providerId === 12 || providerId === 6 || providerId === 36 || providerId === 46) && isAdmin && (
        <HeaderTitle width={WIDTH_CONTENT_TABLE[1]}>{'Артикул 1c'}</HeaderTitle>
      )}

      {contentMode !== MODES_CONTENT_TABLE.STOCKS && <HeaderTitle width={WIDTH_CONTENT_TABLE[1]}>Бренд</HeaderTitle>}

      <HeaderTitle width={WIDTH_CONTENT_TABLE[2]}>Название товара</HeaderTitle>

      {contentMode === MODES_CONTENT_TABLE.STOCKS && (
        <>
          <HeaderTitle width={WIDTH_CONTENT_TABLE[3]} centerText>
            Остаток общий
          </HeaderTitle>
          {isCityStocks && (
            <>
              <HeaderTitle width={WIDTH_CONTENT_TABLE[3]} centerText>
                Остаток МСК
              </HeaderTitle>
              <HeaderTitle width={WIDTH_CONTENT_TABLE[3]} centerText>
                Остаток ЕКБ
              </HeaderTitle>
            </>
          )}

          {isSmallProvider && (
            <>
              <HeaderTitle width={WIDTH_CONTENT_TABLE[3]} centerText>
                Кол-во в упаковке
              </HeaderTitle>
              <HeaderTitle width={WIDTH_CONTENT_TABLE[3]} centerText>
                Мин. опт
              </HeaderTitle>
              <HeaderTitle width={WIDTH_CONTENT_TABLE[4]} centerText>
                Цена за одну
              </HeaderTitle>
              <HeaderTitle width={WIDTH_CONTENT_TABLE[4]} centerText>
                Курс
              </HeaderTitle>
            </>
          )}

          <HeaderTitle width={WIDTH_CONTENT_TABLE[4]} centerText>
            Цена, руб
          </HeaderTitle>
          <HeaderTitle width={WIDTH_CONTENT_TABLE[3]} centerText>
            Ставка НДС
          </HeaderTitle>
          <HeaderTitle width={WIDTH_CONTENT_TABLE[3]} centerText>
            Ед. изм.
          </HeaderTitle>
          {isMinPackage && (
            <>
              <HeaderTitle width={WIDTH_CONTENT_TABLE[4]} centerText style={{ fontSize: '10px' }}>
                Мин. упаковка / шаг
              </HeaderTitle>
              <HeaderTitle width={WIDTH_CONTENT_TABLE[4]} centerText>
                Запрет нектратного набора
              </HeaderTitle>
            </>
          )}
          {isAdmin && (
            <>
              <HeaderTitle width={WIDTH_CONTENT_TABLE[9]} centerText>
                Способ упаковки
              </HeaderTitle>
              <HeaderTitle width={WIDTH_CONTENT_TABLE[9]} centerText>
                Штрихкод
              </HeaderTitle>
            </>
          )}

          <HeaderTitle width={WIDTH_CONTENT_TABLE[1]} centerText>
            Дата создания
          </HeaderTitle>
          <HeaderTitle width={WIDTH_CONTENT_TABLE[1]} centerText>
            Дата обновления
          </HeaderTitle>
          <HeaderTitle width={WIDTH_CONTENT_TABLE[3]} centerText>
            Дней после обновления
          </HeaderTitle>
        </>
      )}

      {contentMode === MODES_CONTENT_TABLE.CONTENT && (
        <>
          <HeaderTitle width={WIDTH_CONTENT_TABLE[7]} centerText>
            Статус карточки
          </HeaderTitle>
          <HeaderTitle width={WIDTH_CONTENT_TABLE[9]} centerText>
            Габариты, см <br />
            ширина х длина х высота
          </HeaderTitle>
          <HeaderTitle width={WIDTH_CONTENT_TABLE[9]} centerText>
            Проверка объема, литры
          </HeaderTitle>

          <HeaderTitle width={WIDTH_CONTENT_TABLE[4]} centerText>
            Вес, кг
          </HeaderTitle>
          <HeaderTitle width={WIDTH_CONTENT_TABLE[9]} centerText>
            Проверка вес, кг
          </HeaderTitle>
          <HeaderTitle width={WIDTH_CONTENT_TABLE[11]} centerText>
            Срок годности, месяцы
          </HeaderTitle>
          <HeaderTitle width={WIDTH_CONTENT_TABLE[7]} centerText>
            Единица измерения
          </HeaderTitle>
        </>
      )}

      {contentMode === MODES_CONTENT_TABLE.WB && (
        <>
          <HeaderTitle width={WIDTH_CONTENT_TABLE[2]} centerText>
            Наименование WB
          </HeaderTitle>
          <HeaderTitle width={WIDTH_CONTENT_TABLE[9]} centerText>
            Категория WB
          </HeaderTitle>
          <HeaderTitle width={WIDTH_CONTENT_TABLE[7]} centerText>
            Заголовок для фотошопа
          </HeaderTitle>
          <HeaderTitle width={WIDTH_CONTENT_TABLE[7]} centerText>
            Единица измерения
          </HeaderTitle>
          <HeaderTitle width={WIDTH_CONTENT_TABLE[7]} centerText>
            Статус карточки
          </HeaderTitle>
        </>
      )}
      {isAdmin && (
        <HeaderTitle width={WIDTH_CONTENT_TABLE[5]} centerText>
          ЧЗ
        </HeaderTitle>
      )}

      <HeaderTitle width={WIDTH_CONTENT_TABLE[9]} centerText>
        Размещение на площадках
        <FilterMarketsDropDown
          market={markets}
          setMarket={setMarkets}
          loadProducts={loadProducts}
          isContentUser={isContentUser && contentMode === MODES_CONTENT_TABLE.WB} //запрет для контенщика менять галку "не было ни разу залито на вб"
        />
      </HeaderTitle>
    </TableHeader>
  );
};

export default ProductsTableHeader;
